import { getHours, getMinutes, isValid, parse, parseISO } from 'date-fns';

import type { Optional } from '@zen/utils/typescript';

import { isParseableAsDateTime } from '../dateTime/parsing';
import type { Time } from '../types';

const REFERENCE_DATE = new Date(2000, 0, 1, 12, 0, 0);

const getTimeFormat = (input: string): string => (input.split(':').length === 3 ? 'HH:mm:ss' : 'HH:mm');

export const parseTime = (input: string | Time): Date => {
  if (typeof input === 'string') {
    return parse(input, getTimeFormat(input), REFERENCE_DATE);
  }

  const result = new Date(REFERENCE_DATE);

  result.setHours(input.hour ?? 0, input.minute ?? 0, 0, 0);

  return result;
};

export const isParseableAsTime = (input: string | Time): boolean => {
  if (typeof input === 'string') {
    return isValid(parse(input, getTimeFormat(input), REFERENCE_DATE));
  }

  const { hour, minute } = input;

  return hour !== null && minute !== null && !isNaN(hour) && !isNaN(minute);
};

export const getTimeFromString = (inputString: Optional<string>): Time => {
  if (!inputString || (!isParseableAsTime(inputString) && !isParseableAsDateTime(inputString))) {
    return { hour: null, minute: null };
  }

  const time = isParseableAsTime(inputString) ? parseTime(inputString) : parseISO(inputString);

  return { hour: getHours(time), minute: getMinutes(time) };
};
